"use client";

import { parseOptions } from "@blocks/RichText/RichText";
import type { AccordionProps } from "@components/ngg";
import { Accordion as NGGAccordion } from "@components/ngg";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { MinusIcon, PlusIcon } from "@ngg/icons";
import type { Links } from "types/contentfulRichText";

import { cn } from "@/lib/utils";

const Icon = ({ open }: any) => (
  <span>
    {open ? (
      <MinusIcon className="text-lg" />
    ) : (
      <PlusIcon className="text-lg" />
    )}
  </span>
);

type Props = AccordionProps & {
  text?: { links: Links; json: any };
  richText?: boolean;
};

/**
 * @deprecated - Use app/_components/Accordion/Accordion.tsx based on Radix UI and shadcn/ui instead.
 */
export default function Accordion({
  children,
  text,
  richText,
  ...props
}: Props) {
  let content = children;

  if (richText && text) {
    content = documentToReactComponents(
      text.json,
      parseOptions({ content: { links: text.links }, ...(props as any) }),
    );
  }
  return (
    <NGGAccordion
      {...props}
      IconComponent={Icon}
      WrapperComponent="div"
      classNames={{
        wrapper: cn("ngg-accordion bg-white", props.classNames?.wrapper),
        button: cn(
          "items-center px-4 py-5 text-left   leading-4",
          props.classNames?.button,
        ),
        panel: cn("px-4 pb-5 pt-0", props.classNames?.panel),
      }}
    >
      {content}
    </NGGAccordion>
  );
}
